import React, { useState, useEffect } from "react";
import { baseUrl, fmtMoney, toCsv, downloadCsv } from '../shared.js';
import '../pages/App.css';
import { StatusChip } from './ui';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from "@mui/x-date-pickers";
import dayjs from 'dayjs';
import moment from "moment";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import DownloadIcon from '@mui/icons-material/Download';

function TotalRow({ label, value, strong }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 1, borderBottom: '1px solid var(--border)' }}>
      <Typography sx={{ fontWeight: strong ? 700 : 500, color: strong ? 'var(--text)' : 'var(--muted)' }}>{label}</Typography>
      <Typography className="app-mono" sx={{ fontWeight: 700, color: strong ? 'var(--primary)' : 'var(--text)' }}>{value}</Typography>
    </Box>
  );
}

// Clickable task row rendered as a soft card with an approval chip.
function TaskCard({ task, onClick }) {
  const approved = task.timeBilled !== null && task.timeBilled !== '';
  return (
    <Box
      onClick={onClick}
      sx={{
        px: 2, py: 1.5,
        borderBottom: '1px solid var(--border)',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick ? { background: 'var(--surface-2)' } : {},
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
        <Typography className="app-mono" sx={{ fontWeight: 700 }}>{moment(task.workDate).format('DD-MM-YYYY')}</Typography>
        <StatusChip domain="approval" value={approved ? 'APPROVED' : 'PENDING'} dot />
      </Box>
      <Typography sx={{ fontSize: 14, color: 'var(--text)', mb: 0.5 }}>{task.workPerformed}</Typography>
      <Box sx={{ display: 'flex', gap: 3, color: 'var(--muted)', fontSize: 13 }}>
        <span>Worked: <b className="app-mono">{task.timeWorked}</b></span>
        <span>Approved: <b className="app-mono">{approved ? task.timeBilled : 'Pending'}</b></span>
      </Box>
    </Box>
  );
}

function ViewOtherTimesheets() {
  const [payrollUsersLoaded, setPayrollUsersLoaded] = useState(false);
  var [payrollUserList, setPayrollUserList] = useState([]);
  const [consultantUsersLoaded, setConsultantUsersLoaded] = useState(false);
  var [consultantUserList, setConsultantUserList] = useState([]);
  const [userSelected, setUserSelected] = useState(false);
  const [approveTimesheetOpen, setApproveTimesheetOpen] = useState(false);
  const [totals, setTotals] = useState({});
  const [type, setType] = useState({});
  const [payrollTotals, setPayrollTotals] = useState({});
  const [tasks, setTasks] = useState({});
  const [payouts, setPayouts] = useState({});
  const [totalsLoaded, setTotalsLoaded] = useState(false);
  const [typeLoaded, setTypeLoaded] = useState(false);
  const [payrollTotalsLoaded, setPayrollTotalsLoaded] = useState(false);
  const [taskListLoaded, setTaskListLoaded] = useState(false);
  const [payoutListLoaded, setPayoutListLoaded] = useState(false);
  const [timesheetData, setTimeSheetData] = useState();
  const [confirmApproveBoxOpen, setConfirmApproveBoxOpen] = useState(false);
  const [confirmMessagePopup, setConfirmMessagePopup] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  useEffect(() => {
    if (!payrollUsersLoaded && localStorage.getItem('canApprovePayroll') === '1') {
      setPayrollUsersLoaded(true);
      const url = baseUrl + 'tasks/payrollUsers';
      fetch(url, { method: 'GET', headers: { 'username': localStorage.getItem('username'), 'bToken': localStorage.getItem('bToken') } })
        .then((res) => res.json())
        .then((json) => setPayrollUserList(json))
        .catch((err) => console.log(err.message));
    }
  });
  useEffect(() => {
    if (!consultantUsersLoaded && localStorage.getItem('canApproveConsultant') === '1') {
      setConsultantUsersLoaded(true);
      const url = baseUrl + 'tasks/consultUsers';
      fetch(url, { method: 'GET', headers: { 'username': localStorage.getItem('username'), 'bToken': localStorage.getItem('bToken') } })
        .then((res) => res.json())
        .then((json) => setConsultantUserList(json))
        .catch((err) => console.log(err.message));
    }
  });

  const post = (path) =>
    fetch(baseUrl + path, {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json', 'username': localStorage.getItem('username'), 'bToken': localStorage.getItem('bToken') },
      body: ("json", JSON.stringify(timesheetData)),
    }).then((r) => r.json());

  const getUserType = () => { if (userSelected) post("pandt/type").then((data) => { if (data.status !== 401) { setType(data.result[0]); setTypeLoaded(true); } else setTypeLoaded(false); }).catch(console.log); };
  const getTotals = () => { if (userSelected) post("pandt/totals").then((data) => { if (data.status !== 401) { setTotals(data.result); setTotalsLoaded(true); } else setTotalsLoaded(false); }).catch(console.log); };
  const getPayrollTotals = () => { if (userSelected) post("payroll/totals").then((data) => { if (data.status !== 401) { setPayrollTotals(data.result); setPayrollTotalsLoaded(true); } else setPayrollTotalsLoaded(false); }).catch(console.log); };
  const getTasks = () => { if (userSelected) post("tasks/list").then((data) => { if (data.status !== 401) { setTasks(data.result); setTaskListLoaded(true); } }).catch(console.log); };
  const getPayouts = () => { if (userSelected) post("payouts/list").then((data) => { if (data.status !== 401) { setPayouts(data.result); setPayoutListLoaded(true); } }).catch(console.log); };

  const approveTimesheet = () => {
    post("task/approve").then((data) => {
      if (data.status !== 401) {
        setConfirmMessage(data.result);
        openConfirmMessage();
        openConfirmApproveBox();
        openApproveTimesheet();
        getTasks();
        getTotals();
        getUserType();
        getPayrollTotals();
      }
    }).catch(console.log);
  };

  const openConfirmMessage = () => setConfirmMessagePopup((v) => !v);
  const openConfirmApproveBox = () => setConfirmApproveBoxOpen((v) => !v);
  const openApproveTimesheet = () => setApproveTimesheetOpen((v) => !v);

  const chooseAnother = () => {
    setUserSelected(false);
    setTimeSheetData();
    setTotals({}); setPayrollTotals({}); setType({}); setTasks({}); setPayouts({});
    setTaskListLoaded(false); setPayoutListLoaded(false); setTotalsLoaded(false); setPayrollTotalsLoaded(false); setTypeLoaded(false);
  };

  useEffect(() => { { !totalsLoaded ? getTotals() : setTotalsLoaded(true); } });
  useEffect(() => { { !payrollTotalsLoaded ? getPayrollTotals() : setPayrollTotalsLoaded(true); } });
  useEffect(() => { { !typeLoaded ? getUserType() : setTypeLoaded(true); } });

  // Load the selected user's task + payout lists once a user is chosen. (The
  // getters guard on userSelected, which is stale inside the Select onChange, so
  // fire them here where userSelected/userId are settled.)
  useEffect(() => {
    if (userSelected) { getTasks(); getPayouts(); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSelected, timesheetData?.userId]);

  const exportTasks = () => {
    const rows = Array.isArray(tasks) ? tasks : [];
    const csv = toCsv(rows, [
      { label: 'Work Date', map: (r) => moment(r.workDate).format('YYYY-MM-DD') },
      { label: 'Work Performed', key: 'workPerformed' },
      { label: 'Time Worked', key: 'timeWorked' },
      { label: 'Approved Time', map: (r) => (r.timeBilled === null ? 'Pending' : r.timeBilled) },
      { label: 'Billed Rate', key: 'billedRate' },
      { label: 'Billed Total', key: 'billedTotal' },
    ]);
    downloadCsv(`timesheets-user-${timesheetData?.userId || 'selected'}.csv`, csv);
  };

  const canApprove = localStorage.getItem('canApprovePayroll') === '1' || localStorage.getItem('canApproveConsultant') === '1';
  if (!canApprove) {
    return (
      <Card sx={{ p: 3, maxWidth: 520, mx: 'auto', textAlign: 'center' }}>
        <Typography sx={{ color: 'var(--muted)' }}>You do not have permission to approve timesheets.</Typography>
      </Card>
    );
  }

  const taskArr = Array.isArray(tasks) ? tasks : [];
  const payoutArr = Array.isArray(payouts) ? payouts : [];

  return (
    <Box>
      {/* Approve timesheet modal */}
      <Dialog open={approveTimesheetOpen} onClose={openApproveTimesheet} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 700 }}>Approve Timesheet</DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 1 }}>
            {timesheetData?.workDate && (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker disabled slotProps={{ textField: { fullWidth: true } }} sx={{ mt: 1, mb: 1 }} label="Work Date" format="YYYY-MM-DD" value={dayjs(timesheetData.workDate)} onChange={() => {}} />
              </LocalizationProvider>
            )}
            <TextField disabled fullWidth margin="dense" label="Work Performed" multiline rows={4} variant="outlined" value={timesheetData?.workPerformed || ''} />
            <TextField disabled fullWidth margin="dense" label="Time Worked" variant="outlined" type="number" value={timesheetData?.timeWorked ?? ''} />
            <TextField
              disabled={!(timesheetData?.billedTotal === null || timesheetData?.timeBilled === '')}
              fullWidth margin="dense" label="Time Billed" variant="outlined" type="number"
              defaultValue={(timesheetData?.timeBilled === null || timesheetData?.timeBilled === '') ? timesheetData?.timeWorked : timesheetData?.timeBilled}
              onChange={(e) => setTimeSheetData({ ...timesheetData, timeBilled: e.target.value })}
            />
            <TextField
              disabled={!(timesheetData?.billedTotal === null || timesheetData?.timeBilled === '')}
              fullWidth margin="dense" label="Billed Rate" variant="outlined" type="number"
              defaultValue={timesheetData?.billedRate}
              onChange={(e) => setTimeSheetData({ ...timesheetData, billedRate: e.target.value })}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button color="inherit" onClick={openApproveTimesheet}>Cancel</Button>
          <Button variant="contained" disabled={!(timesheetData?.billedTotal === null)} onClick={openConfirmApproveBox}>Approve Timesheet</Button>
        </DialogActions>
      </Dialog>

      {/* Confirm approve */}
      <Dialog open={confirmApproveBoxOpen} onClose={openConfirmApproveBox} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 700 }}>Confirm Approve Timesheet</DialogTitle>
        <DialogActions>
          <Button color="inherit" onClick={openConfirmApproveBox}>Cancel</Button>
          <Button variant="contained" onClick={approveTimesheet}>Confirm</Button>
        </DialogActions>
      </Dialog>

      {/* Message */}
      <Dialog open={confirmMessagePopup} onClose={openConfirmMessage} maxWidth="xs" fullWidth>
        <DialogContent><Typography>{confirmMessage}</Typography></DialogContent>
        <DialogActions><Button variant="contained" onClick={openConfirmMessage}>OK</Button></DialogActions>
      </Dialog>

      <Card sx={{ p: { xs: 2.5, md: 3.5 } }}>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>Approve Timesheets</Typography>

        {userSelected ? (
          <Button variant="outlined" color="inherit" sx={{ color: 'var(--muted)', borderColor: 'var(--border-strong)', mb: 2 }} onClick={chooseAnother}>
            Clear Selected User
          </Button>
        ) : (
          <>
            {localStorage.getItem('canApprovePayroll') === '1' && (
              <FormControl fullWidth margin="dense">
                <InputLabel id="payrollUserLabel">Select Payroll User</InputLabel>
                <Select labelId="payrollUserLabel" label="Select Payroll User" value=""
                  onChange={(e) => { setUserSelected(true); setTimeSheetData({ ...timesheetData, userId: e.target.value }); getTasks(); getPayouts(); getTotals(); getUserType(); getPayrollTotals(); }}>
                  {payrollUserList.map((u) => (<MenuItem value={u.id} key={u.id}>{u.username}</MenuItem>))}
                </Select>
              </FormControl>
            )}
            {localStorage.getItem('canApproveConsultant') === '1' && (
              <FormControl fullWidth margin="dense">
                <InputLabel id="consultUserLabel">Select Consultant User</InputLabel>
                <Select labelId="consultUserLabel" label="Select Consultant User" value=""
                  onChange={(e) => { setUserSelected(true); setTimeSheetData({ ...timesheetData, userId: e.target.value }); getTasks(); getPayouts(); getTotals(); getUserType(); getPayrollTotals(); }}>
                  {consultantUserList.map((u) => (<MenuItem value={u.id} key={u.id}>{u.username}</MenuItem>))}
                </Select>
              </FormControl>
            )}
          </>
        )}

        {userSelected && (
          <Box sx={{ mt: 1 }}>
            {type?.isConsultant === 1 && (
              <Box sx={{ mb: 2 }}>
                <TotalRow label="Approved Task Totals" value={fmtMoney(totals[0]?.sum)} />
                <TotalRow label="Payout Totals" value={fmtMoney(totals[1]?.sum)} />
                <TotalRow label="Balance" value={fmtMoney((totals[0]?.sum ?? 0) - (totals[1]?.sum ?? 0))} strong />
              </Box>
            )}
            {type?.isPayroll === 1 && (
              <Box sx={{ mb: 2 }}>
                <TotalRow label={`${payrollTotals[0]?.workWeek || 'This week'} Total Hours`} value={payrollTotals[0]?.hoursWorkedBilled ?? 0} />
                <TotalRow label={`${payrollTotals[1]?.workWeek || 'Last week'} Total Hours`} value={payrollTotals[1]?.hoursWorkedBilled ?? 0} />
              </Box>
            )}

            {/* Tasks */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2, mb: 1 }}>
              <Typography sx={{ fontWeight: 700 }}>Tasks {`(${totals[0]?.count ?? taskArr.length})`}</Typography>
              <Button size="small" startIcon={<DownloadIcon />} onClick={exportTasks} disabled={!taskArr.length}>Export CSV</Button>
            </Box>
            <Box sx={{ border: '1px solid var(--border)', borderRadius: 'var(--r-sm)', overflow: 'hidden' }}>
              {taskListLoaded && taskArr.length ? (
                taskArr.map((task, i) => (
                  <TaskCard key={i} task={task} onClick={() => { setTimeSheetData({ ...timesheetData, id: task.id, workDate: task.workDate, workPerformed: task.workPerformed, timeWorked: task.timeWorked, timeBilled: task.timeBilled, billedRate: task.billedRate, billedTotal: task.billedTotal }); openApproveTimesheet(); }} />
                ))
              ) : (
                <Box sx={{ p: 2, color: 'var(--muted)', textAlign: 'center' }}>No tasks for this user.</Box>
              )}
            </Box>

            {/* Payouts (consultant only) */}
            {type?.isConsultant === 1 && (
              <>
                <Typography sx={{ fontWeight: 700, mt: 3, mb: 1 }}>Payouts {`(${totals[1]?.count ?? payoutArr.length})`}</Typography>
                <Box sx={{ border: '1px solid var(--border)', borderRadius: 'var(--r-sm)', overflow: 'hidden' }}>
                  {payoutListLoaded && payoutArr.length ? (
                    payoutArr.map((p, i) => (
                      <Box key={i} sx={{ px: 2, py: 1.5, borderBottom: '1px solid var(--border)' }}>
                        <Typography className="app-mono" sx={{ fontWeight: 700 }}>{moment(p.updatedAt).format('DD-MM-YYYY')}</Typography>
                        <Typography sx={{ fontSize: 14 }}>{p.payoutComment}</Typography>
                        <Typography sx={{ fontSize: 13, color: 'var(--muted)' }}>Amount: <b className="app-mono">{fmtMoney(p.payoutAmount)}</b></Typography>
                      </Box>
                    ))
                  ) : (
                    <Box sx={{ p: 2, color: 'var(--muted)', textAlign: 'center' }}>No payouts for this user.</Box>
                  )}
                </Box>
              </>
            )}
          </Box>
        )}
      </Card>
    </Box>
  );
}

export default ViewOtherTimesheets;
